import React from "react";

const ProductSpecificationCard = ({ product, specifications = [] }) => {
    const attributes = product.attributes || [];

    // Agar specifications config nahi aayi, to saare attributes dikhao (fallback)
    if (!specifications || specifications.length === 0) {
        if (attributes.length === 0) return null;

        return (
            <div className="card mb-4">
                <div className="card-header">
                    <h5 className="mb-0">PRODUCT SPECIFICATIONS</h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        {attributes.map((attr, index) => (
                            <div className="col-md-4 mb-2" key={attr.id || index}>
                                <strong>{attr.attr_key.replace(/_/g, ' ').toUpperCase()}:</strong>{' '}
                                {attr.attr_value || '-'}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    // ⭐ Template ke according filter karo
    const allowedKeys = specifications.map(s => s.key);

    // Attributes ko key → value map banao
    const attributeMap = {};
    attributes.forEach(attr => {
        attributeMap[attr.attr_key] = attr.attr_value;
    });

    // Order maintain karte hue sirf allowed keys dikhao
    const visibleSpecs = specifications
        .filter(spec => {
            // Skip karo agar attr_value nahi hai aur na hi product mein
            const val =
                attributeMap[spec.key] ??
                product[spec.key] ??
                product[`${spec.key}_ids`];

            // Agar value null/undefined/empty → skip
            if (val === null || val === undefined || val === '') return false;
            return true;
        })
        .map(spec => {
            let value =
                attributeMap[spec.key] ??
                product[spec.key] ??
                product[`${spec.key}_ids`] ??
                '-';

            // Agar array hai (multi-select), join karo
            if (Array.isArray(value)) {
                value = value.join(', ');
            }

            return {
                key: spec.key,
                label: spec.label || spec.key,
                value,
                type: spec.type,
            };
        });

    if (visibleSpecs.length === 0) return null;

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0">PRODUCT SPECIFICATIONS</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {visibleSpecs.map((spec, index) => (
                        <div className="col-md-4 mb-2" key={spec.key || index}>
                            <strong>{spec.label}:</strong> {spec.value}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductSpecificationCard;